import {
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Button,
  Typography,
  IconButton,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ConfirmModal = ({
  size: _size = null,
  title = 'Are you sure?',
  onClose,
  message = 'Are you sure?',
  className = '',
  cancelText = '',
  confirmText = 'Ok',
  cancelColor = '',
  confirmColor = 'primary',
  buttonsComponent = null,
  hideCloseIcon = false,
  URL,
}) => {
  const redirectUrl = (path) => window.location.replace(path);

  let buttonsContent = (
    <>
      {cancelText && (
        <Button
          id="confirmModalCancel"
          variant="outlined"
          color={cancelColor || 'inherit'}
          onClick={() => (URL ? redirectUrl(URL) : onClose(false))}
          sx={{ minWidth: 100 }}
        >
          {cancelText}
        </Button>
      )}
      <Button
        id="confirmModal"
        variant="contained"
        color={
          confirmColor === 'primary' ? 'primary' : confirmColor || 'primary'
        }
        onClick={() => onClose(true)}
        sx={{ minWidth: 100 }}
      >
        {confirmText}
      </Button>
    </>
  );

  if (buttonsComponent) {
    const CustomComponent = buttonsComponent;
    buttonsContent = <CustomComponent onClose={onClose} />;
  }
  return (
    <Dialog
      open={true}
      maxWidth="sm"
      fullWidth
      onClose={() => onClose(false)}
      className={`confirm-modal ${className}`}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          },
        },
      }}
    >
      <DialogTitle
        component="div"
        sx={{
          display: 'flex !important',
          alignItems: 'center',
          justifyContent: 'space-between',
          pb: 2,
          pt: 3,
          px: 3,
          m: 0,
          minHeight: 56,
          '&.MuiDialogTitle-root': {
            padding: '24px 24px 16px 24px',
            margin: 0,
          },
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 600,
            fontSize: '20px',
            color: '#0F1214',
            flex: 1,
            display: 'block !important',
            visibility: 'visible !important',
            opacity: 1,
            margin: 0,
            padding: 0,
          }}
        >
          {title || 'Are you sure?'}
        </Typography>
        {!hideCloseIcon && (
          <IconButton
            id="closeIcon"
            onClick={() => onClose(false)}
            sx={{
              color: '#929398',
              ml: 2,
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </DialogTitle>
      <Divider />
      <DialogContent
        sx={{
          px: 3,
          py: 3,
        }}
      >
        {!!message && (
          <Typography
            variant="body1"
            sx={{
              color: '#0F1214',
              fontSize: '16px',
              lineHeight: 1.5,
            }}
          >
            {message}
          </Typography>
        )}
      </DialogContent>
      <Divider />
      <DialogActions
        sx={{
          px: 3,
          py: 2.5,
          gap: 1.5,
          justifyContent: 'flex-end',
        }}
      >
        {buttonsContent}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
